import React, { useCallback, useRef, useEffect, useState, useContext } from "react"
import store from '../utilities/localStore'
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router-dom';
import {themeColors, gradients, radius} from '../constants'
import { Context as AuthContext } from '../contexts/AuthContext'
import { Context as FilterContext } from '../contexts/FilterPaymentContext'
import { usePayments, useAccountingBook, useAccountingBookSummary, useIsDesktop } from '../hooks'

import {
  FullPageLoader,
  FontAwesomeIcon,
  PaymentInfoHeader,
  ConfirmBox,
  PaymentsHeader,
  BookTabsHeader,
  Loading,
  EmptyResult,
  TransactionItem,
} from '../components'
import PaymentEditPage from './PaymentEditPage/PaymentEditPage'
import formatAmount from '../utilities/formatAmount'

const PaymentsPage = (props) => {
  const { group_id, accounting_book_id } = useParams();
  const history = useHistory();
  const isDesktop = useIsDesktop()
  /* eslint-disable no-unused-vars */
  const [ editMode, setEditMode ] = useState(false)
  const [ selectedPaymentIds, setSelectedPaymentIds ] = useState([])
  const [fullPageLoad, setFullPageLoad] = useState(false)
  const { state: authState } = useContext(AuthContext)
  const { state: filterState, resetForm, setPayers, setOwers } = useContext(FilterContext)

  /* eslint-disable no-unused-vars */
  const [ small, setSmall ] = useState(false)
  /* eslint-disable no-unused-vars */
  const [users, accountingBookDetails, accountingBookLoading, _err, _setUsers, loadAccountingBook] = useAccountingBook(authState)
  const [payments, paymentLoading, getPayments] = usePayments(authState, filterState, "")
  const [selectAll, setSelectAll] = useState(false)
  /* eslint-disable no-unused-vars */
  const [summary, loading, err, getAccountingBook, currentUserDebt, settlements] = useAccountingBookSummary(authState)
  const [index, setIndex] = useState(props.index)

  // Desktop master-detail: which payment is open in the right-hand edit pane,
  // and a nonce to remount the pane after a save so it reloads fresh values.
  const [selectedPayment, setSelectedPayment] = useState(null)
  const [editNonce, setEditNonce] = useState(0)

  const summaryRef = useRef();

  const [headerContainerHeight, setHeaderContainerHeight] = useState(120)

  const resetFilter = () => {
    resetForm()
    setFullPageLoad(true)
    getPayments('', () => setFullPageLoad(false))
  }

  // Name lookup lives in the app-bar (PaymentsHeader). The magnifier toggles a
  // search box that filters the already-loaded payments list on the client by
  // name (description, payer and ower display names) — no extra API calls.
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const handleSearchClick = () => {
    setSearchOpen((open) => {
      if (open) { setSearchQuery('') }
      return !open
    })
  }

  const matchesSearch = (payment, query) => {
    const needle = query.trim().toLowerCase()
    if (!needle) { return true }
    const haystacks = []
    if (payment.description) { haystacks.push(payment.description) }
    if (payment.payer_display_name) { haystacks.push(payment.payer_display_name) }
    if (Array.isArray(payment.allocations)) {
      payment.allocations.forEach((a) => { if (a.ower_display_name) { haystacks.push(a.ower_display_name) } })
    }
    if (Array.isArray(payment.payment_payers)) {
      payment.payment_payers.forEach((pp) => { if (pp.user_display_name) { haystacks.push(pp.user_display_name) } })
    }
    return haystacks.some((h) => h.toLowerCase().includes(needle))
  }

  const visiblePayments = payments.filter((p) => matchesSearch(p, searchQuery))

  useEffect(() => {
    if (accountingBookDetails.current !== undefined) {
      setHeaderContainerHeight(accountingBookDetails.current ? 120 : 175)
    }
  }, [accountingBookDetails])


  const discliamerClosedCallback = () => {
    loadAccountingBook()
    setHeaderContainerHeight(120)
  }

  const handleScroll = useCallback((e, set) => {
    set({ x: { value: e.target.scrollLeft }, y: { value: e.target.scrollTop } })
  }, []);

//   useEffect(() => {
//     const div = paymentContainerRef.current
//     if (div) {
//       div.addEventListener('scroll', (e) => handleScroll(e, setPaymentContainerScrollInfo));
//     }
//   }, [paymentContainerRef.current]);


  const [paymentOverflow, setPaymentOverflow] = useState('hidden')

  // if (paymentContainerScrollInfo.y.value > (headerContainerHeight - 25) && paymentOverflow !== 'auto') {
  //   setPaymentOverflow('auto')
  //   paymentsRef.current.scroll(0, 5)
  // }

  let paymentsHeight = "calc(100%)"
  let paymentStyle =  {
    background: '#FFFFFF',
    overflow: "auto",
    marginTop: small ? '0px' : '1px',
    flexGrow: 1,
    height: paymentsHeight,
    paddingBottom: payments.length > 0 ? '40px' : '24px',
  }

  let paymentContainerStyle = {
    flexGrow: 1,
    minHeight: 0,
    overflow: 'auto',
  }

  const handleIndexChanged = (i) => {
    setIndex(i)
  }

  const [deleteActive, seDeleteActive] = useState(null)

  let deleteConfirmBox = <ConfirmBox
    title="刪除帳款"
    confirmed={() => deletePayment(deleteActive)}
    canceled={() => { seDeleteActive(null) }}
    confirm_text="確認"
    cancel_text="取消">
    <div style={{ paddingBottom: '20px' }}> 確認刪除 {deleteActive ? deleteActive.description : null } 這筆帳款嗎? </div>
    </ConfirmBox>

  const deletePayment = (payment) => {
    setFullPageLoad(true)

    authState.api.deletePayments(group_id, accounting_book_id, {
      payment_ids: [payment.id],
      builder_id: authState.userLineIdToken
    }).then(function (response) {
      getPayments('', () => setFullPageLoad(false))
      getAccountingBook()
      seDeleteActive(null)
      setSelectedPayment(null)
    })
      .catch(function (error) {
        console.log(error)
        alert('刪除失敗')
        seDeleteActive(null)
        setFullPageLoad(false)
      })
  }

  const handleDeletePayment = (payment) =>{
    seDeleteActive(payment)
  }

  const handleEditModeChanged = (checked, id) => {
    let ids
    if (checked) {
      if (selectedPaymentIds) {
        ids = selectedPaymentIds
        ids.push(id)
        setSelectedPaymentIds(ids)
      } else {
        setSelectedPaymentIds([id])
      }
    } else {
      if (selectedPaymentIds) {
        ids = selectedPaymentIds
        ids = ids.filter((el) => el !== id)
        setSelectedPaymentIds(ids)
      }
    }
  }

  const moment = require('moment-timezone');

  function isTodayInHongKong(dateString) {
    const hongKongDate = moment.tz(dateString, "YYYY-MM-DD", "Asia/Hong_Kong");
    const todayHongKong = moment.tz("Asia/Hong_Kong");

    return hongKongDate.isSame(todayHongKong, 'day');
  }

  function isYesterdayInHongKong(dateString) {
    const date = moment.tz(dateString, "YYYY-MM-DD", "Asia/Hong_Kong");
    const yesterday = moment.tz("Asia/Hong_Kong").subtract(1, 'days');
    return date.isSame(yesterday, 'day');
  }
  const dateLabel = (d) => {
    if (isTodayInHongKong(d)) { return '今日' }
    if (isYesterdayInHongKong(d)) { return '昨日' }
    return d
  }

  const renderPaymentCard = (payment) => (
    <TransactionItem
      deleted={handleDeletePayment}
      selectedPaymentIds={selectedPaymentIds}
      changed={handleEditModeChanged}
      key={payment.id}
      object={payment}
      editMode={editMode}
      {...accountingBookDetails}
    />
  )

  // Desktop master-detail: rows select (no expand) and drive the right pane.
  const renderSelectableCard = (payment) => (
    <TransactionItem
      key={payment.id}
      object={payment}
      onSelect={setSelectedPayment}
      selected={selectedPayment && String(selectedPayment.id) === String(payment.id)}
      {...accountingBookDetails}
    />
  )

  // Group payments by date so desktop can render a single-column selectable
  // list while mobile keeps the original flat (separator + card) stream.
  let paymentGroups = []
  let currentDate = null
  visiblePayments.forEach(payment => {
    if (payment.created_at_group !== currentDate) {
      currentDate = payment.created_at_group
      paymentGroups.push({ key: currentDate, label: dateLabel(currentDate), items: [] })
    }
    paymentGroups[paymentGroups.length - 1].items.push(payment)
  })

  const paymentLabels = paymentGroups.flatMap((g) => [
    <div key={g.key} style={styles.dateSeparator}>{g.label}</div>,
    ...g.items.map(renderPaymentCard),
  ])

  const desktopPaymentLabels = paymentGroups.flatMap((g) => [
    <div key={g.key} style={styles.dateSeparator}>{g.label}</div>,
    ...g.items.map(renderSelectableCard),
  ])

  // refresh the list in place and reload the edit pane with saved values
  const handlePaymentSaved = () => {
    getPayments('')
    getAccountingBook()
    setEditNonce((n) => n + 1)
  }

  const handleAddPayment = () => {
    history.push(`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/payments/new`)
  }

  let settlementsObjects = settlements.map(object => {
    return <>
      <div className="d-flex p-4">
        {object.user_display_name}
        {object.debt}
      </div>
      </>
  })

  let load = props.index === 0 ? paymentLoading : loading
  let paymentSizeCache = store.get(`accountingBookPaymentsSize-${accounting_book_id}`)

  // Primary action pinned to the bottom as a full-width button, aligned with
  // the overview page. Locked books show a disabled lock state instead.
  const isLocked = accountingBookDetails.lock_status === "locked"
  const footerBtn = (
    <div style={styles.footer}>
      <button
        type="button"
        style={isLocked ? { ...styles.addBtn, ...styles.addBtnLocked } : styles.addBtn}
        onClick={isLocked ? undefined : handleAddPayment}
        disabled={isLocked}>
        {isLocked
          ? <><FontAwesomeIcon faicon='faLock' style={{ fontSize: '14px' }} /> 帳本已鎖定</>
          : <>＋ 新增帳款</>}
      </button>
    </div>
  )

  const desktopSearchBox = (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <FontAwesomeIcon
        faicon='faSearch'
        style={{ position: 'absolute', left: '12px', fontSize: '13px', color: themeColors.gray700, pointerEvents: 'none' }}
      />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder='搜尋帳款名稱或成員'
        style={{
          border: `1px solid ${themeColors.gray100}`,
          borderRadius: radius.pill,
          padding: '8px 16px 8px 32px',
          fontSize: '14px',
          outline: 'none',
          width: '220px',
          background: themeColors.gray100,
        }}
      />
    </div>
  )

  // Shared empty-state for an active search that matches nothing.
  const noSearchMatch = searchQuery.trim().length > 0

  if (isDesktop) {
    return (
      <>
        <div style={desktopStyles.shell}>
          {/* left: payments list (single column, selectable) */}
          <div style={desktopStyles.listPane}>
            <div style={desktopStyles.listHeader}>
              <span style={desktopStyles.listTitle}>帳目明細</span>
              {desktopSearchBox}
            </div>
            <PaymentInfoHeader
              currentUserDebt={currentUserDebt}
              users={users.filter(u => u.coverCost)}
              discliamerClosedCallback={discliamerClosedCallback}
              index={index}
              loading={paymentLoading}
              paymentSize={paymentSizeCache ? paymentSizeCache : payments.length}
              accountingBookDetails={accountingBookDetails}
              resetFilter={resetFilter}
            />
            <div style={desktopStyles.listScroll}>
              {
                load ? <Loading /> :
                  visiblePayments.length > 0 ? desktopPaymentLabels :
                    <EmptyResult message={noSearchMatch ? '找不到符合的帳款' : '還沒有任何款項喔'}/>
              }
            </div>
          </div>

          {/* right: edit pane for the selected payment */}
          <div style={desktopStyles.editPane}>
            {selectedPayment ? (
              <>
                <div style={desktopStyles.editHeader}>
                  <span style={desktopStyles.editTitle}>{selectedPayment.paid_back ? '還款紀錄' : '編輯帳款'}</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <button onClick={() => seDeleteActive(selectedPayment)} style={desktopStyles.deleteBtn}>刪除</button>
                    <button onClick={() => setSelectedPayment(null)} style={desktopStyles.closeBtn} aria-label="關閉">✕</button>
                  </div>
                </div>
                {selectedPayment.paid_back ? (
                  /* 還款 records can only be deleted, never edited (mirrors mobile) */
                  <div style={desktopStyles.paybackBody}>
                    <div style={desktopStyles.paybackAmount}>
                      {formatAmount(selectedPayment.amount, accountingBookDetails.exponent || 0, accountingBookDetails.currency_symbol || '$')}
                    </div>
                    <div style={desktopStyles.paybackSub}>{selectedPayment.payer_display_name} 還款</div>
                    <div style={desktopStyles.paybackNote}>還款紀錄無法編輯，如需修正請刪除後重新建立。</div>
                  </div>
                ) : (
                  <div style={desktopStyles.editBody}>
                    <PaymentEditPage
                      key={`${selectedPayment.id}-${editNonce}`}
                      embedded
                      paymentId={selectedPayment.id}
                      onSaved={handlePaymentSaved}
                    />
                  </div>
                )}
              </>
            ) : (
              <div style={desktopStyles.empty}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>🧾</div>
                選擇左側一筆帳款即可編輯
              </div>
            )}
          </div>
        </div>

        { deleteActive ? deleteConfirmBox : null }
        { fullPageLoad ? <FullPageLoader /> : null }
      </>
    )
  }

  return(
    <>
      <div style={styles.bg}>
        <PaymentsHeader
          ndex={index}
          loading={paymentLoading}
          paymentSize={payments.length}
          accountingBookDetails={accountingBookDetails}
          onSearchClick={handleSearchClick}
          searchActive={searchOpen}
          backLink={`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/overview`}
        />

        {
          searchOpen &&
            <div style={styles.searchBar}>
              <FontAwesomeIcon
                faicon='faSearch'
                style={{ position: 'absolute', left: '28px', fontSize: '14px', color: themeColors.gray700, pointerEvents: 'none' }}
              />
              <input
                type="text"
                autoFocus
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder='搜尋帳款名稱或成員'
                style={styles.searchInput}
              />
              {
                searchQuery &&
                  <button type="button" style={styles.searchClear} onClick={() => setSearchQuery('')} aria-label="清除">✕</button>
              }
            </div>
        }

        <div style={paymentContainerStyle}>
          <PaymentInfoHeader
            currentUserDebt={currentUserDebt}
            users={users.filter(u => u.coverCost)}
            discliamerClosedCallback={discliamerClosedCallback}
            index={index}
            loading={paymentLoading}
            paymentSize={paymentSizeCache ? paymentSizeCache : payments.length}
            accountingBookDetails={accountingBookDetails}
            resetFilter={resetFilter}
          />


          {
            load ? <div style={paymentStyle}><Loading /></div> :
              <div style={paymentStyle} >
                {
                  visiblePayments.length > 0 ?
                    paymentLabels
                    : <EmptyResult message={noSearchMatch ? '找不到符合的帳款' : '還沒有任何款項喔'}/> }
              </div>}
        </div>
        { footerBtn }
      </div>

      { deleteActive ? deleteConfirmBox : null }
      {
        fullPageLoad ? <FullPageLoader /> : null
      }
    </>
  )
}

const desktopStyles = {
  shell: {
    height: '100%',
    display: 'flex',
    flexFlow: 'row',
    overflow: 'hidden',
  },
  listPane: {
    flex: '0 0 400px',
    minWidth: 0,
    display: 'flex',
    flexFlow: 'column',
    borderRight: '1px solid #ececec',
    overflow: 'hidden',
  },
  listHeader: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 16px 8px',
  },
  listTitle: { fontSize: '16px', fontWeight: 600, color: '#2d2d2d' },
  listScroll: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    paddingBottom: '24px',
  },
  editPane: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexFlow: 'column',
    position: 'relative',
  },
  editHeader: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 22px',
    borderBottom: '1px solid #ececec',
  },
  editTitle: { fontSize: '16px', fontWeight: 600, color: '#2d2d2d' },
  deleteBtn: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: '#E11D48',
    fontSize: '14px',
    fontWeight: 600,
  },
  closeBtn: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: '#909090',
    fontSize: '18px',
    lineHeight: 1,
  },
  editBody: {
    flex: '1 1 auto',
    minHeight: 0,
    position: 'relative',
    overflow: 'hidden',
  },
  empty: {
    flex: '1 1 auto',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: themeColors.gray600,
    fontSize: '14px',
  },
  paybackBody: {
    flex: '1 1 auto',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '24px',
  },
  paybackAmount: {
    fontSize: '34px',
    fontWeight: 600,
    color: '#0c533c',
  },
  paybackSub: {
    fontSize: '14px',
    color: themeColors.gray900,
    marginTop: '8px',
  },
  paybackNote: {
    fontSize: '13px',
    color: '#909090',
    marginTop: '18px',
    maxWidth: '280px',
    lineHeight: 1.6,
  },
}

const styles = {
  bg: {
    width: '100%',
    // Cap to a phone-width column and center on large screens; no-op on phones.
    maxWidth: '600px',
    margin: '0 auto',
    height: 'calc(100vh)',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column',
    maxHeight: '-webkit-fill-available',
    position: 'relative',
  },
  h1: {
    padding: '12px',
    textAlign: 'center',
    fontSize: '1.5rem',
  },
  dateSeparator: {
    fontSize: '12px',
    textAlign: 'left',
    paddingTop: '12px',
    paddingLeft: '16px',
    fontWeight: 600,
    color: themeColors.gray700,
  },
  searchBar: {
    flex: '0 0 auto',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    background: '#ffffff',
    borderBottom: '1px solid #f2f2f2',
  },
  searchInput: {
    width: '100%',
    border: `1px solid ${themeColors.gray100}`,
    borderRadius: radius.pill,
    padding: '10px 36px 10px 30px',
    fontSize: '14px',
    outline: 'none',
    background: themeColors.gray100,
  },
  searchClear: {
    position: 'absolute',
    right: '26px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: themeColors.gray700,
    fontSize: '14px',
    lineHeight: 1,
  },
  footer: {
    flex: '0 0 auto',
    padding: '12px 16px max(16px, env(safe-area-inset-bottom))',
    background: '#ffffff',
    borderTop: '1px solid #f2f2f2',
  },
  addBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    padding: '16px',
    border: 'none',
    borderRadius: radius.lg,
    background: gradients.brandGreen,
    color: '#ffffff',
    fontFamily: "'Noto Sans TC', sans-serif",
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    boxShadow: '0 6px 16px rgba(7, 105, 77, 0.22)',
  },
  addBtnLocked: {
    background: themeColors.red,
    cursor: 'default',
    boxShadow: 'none',
  },
}


export default PaymentsPage
